module.exports = __webpack_public_path__ + "media/site_templates/www.furnituremovingservices.com.au/images/our_services_1-881ba69c0a1cc85234bc86a674cce841.jpg";